/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '../../../services/toast';
export default {
  name: 'sa-organization-user-create',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      first_name:'',
      last_name:'',
      email:'',
      organization:'',
      division:'',
      area_of_work:'',
      department:'',
      designation:''
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
            let data = {
              organization:this.$route.params.orgUserId,
              email:this.email,
            }
            if(this.first_name != null && this.first_name != ''){
              data.first_name = this.first_name;
            }
            if(this.last_name != null && this.last_name != ''){
              data.last_name = this.last_name;
            }
            if(this.area_of_work != null && this.area_of_work != ''){
              data.area_of_work = this.area_of_work;
            }
            if(this.department != null && this.department != ''){
              data.department = this.department;
            }
            if(this.designation != null && this.designation != ''){
              data.designation = this.designation;
            }
            if(this.division != null && this.division != ''){
              data.division = this.division;
            }
            this.$store.dispatch('createSaOrgUserFun', data)
              .then((res) => {  
                  toast.success(res.data.msg);            
                  this.$router.push('/sa/organization/')
              }).catch((err) => {
                toast.error(err.data.data.email || err.data.user_msg || err.data.msg);
              })
            return;
        }
      });
    }
  }
}


